import { render, staticRenderFns } from "./pie-task.vue?vue&type=template&id=ee23f39e&scoped=true"
import script from "./pie-task.vue?vue&type=script&lang=js"
export * from "./pie-task.vue?vue&type=script&lang=js"
import style0 from "./pie-task.vue?vue&type=style&index=0&id=ee23f39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee23f39e",
  null
  
)

export default component.exports